<template>
  <div class="Login"  >
    <!-- Login page -->
    <div class="logo"><img :src="require(`../assets/images/${logo}`)" height="200" alt="Icon" class="fox">
      <form method="post" :model="form"  @submit.prevent="postNow">
        <div class="container1">
          <label for="uname"><b>{{$t('Username')}}</b></label>
          <input type="text" v-model="input.username" v-bind:placeholder="$t('enter-username')" name="uname" required>
          <label for="psw"><b>{{$t('Password')}}</b></label>
          <input type="password" v-model="input.password" v-bind:placeholder="$t('enter-password')" name="psw" required>
<!--          <label for="psw"><b>Captcha</b></label>-->
          <!-- **captcha need to be set for the actual site**, I can't use on localhost so I disabled it -->
           <vue-recaptcha v-if="useRecaptcha" ref="recaptcha"
            @verify="onVerify" :sitekey="recaptchaSiteKey" :loadRecaptchaScript="true" theme="dark">
          </vue-recaptcha>
          <button class="logb" type="submit">{{$t('Login')}}</button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from "axios";
  export default {
    name: 'Login',
    data() {
      return {
        isAuthenticated: false,
        input: {
          username: "",
          password: "",

        },
        form: {
          robot: false,
        },
        logo: process.env.VUE_APP_LOGO_IMAGE,
        useRecaptcha: process.env.VUE_APP_USE_RECAPTCHA,
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        captchaResponse: null
      }
    },
    components: {
      'vue-recaptcha': VueRecaptcha
    },
    methods: {
      //POST login
      //form.robot is for recaptcha
      postNow: async function() {
        this.$emit("authenticated", false);
        try {
          const res = await  axios.post('/api/login/',  {
            username: this.input.username,
            password: this.input.password,
            'g-recaptcha-response': this.captchaResponse
          },{withCredentials: true}).then(res => res.data);
            if (res.state === 'ok') {
              sessionStorage.setItem("authenticated", true);
              this.$session.set('authenticated', true)
              this.$socket.connect();
              this.$router.replace({ name: "Main", params: {login: res.data.name, id: res.data.id } });
            } else {
              this.$notify({text: (res.message || "The username and / or password is incorrect"), type: 'warn'});
              }
        } catch (err) {
          this.$notify({text: "Something go wrong. We are working on problem solving", type: 'warn'});
        }
      },
      onVerify: function (response) {
        this.captchaResponse = response;
      }
    },
    mounted() {
      this.$socket.disconnect();
      console.log(process.env.VUE_APP_LOGO_IMAGE)
    }
  }
</script>


<style>

html.Login {
  background: #749f80;
}
html{
  background: #363837;
  background-image: url("../assets/images/back.jpg");
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
body {
  background: radial-gradient(circle, rgba(52,124,142,1) 24%, rgba(19,89,103,1) 51%);
  font-family: Arial, Helvetica, sans-serif;
  background: #363837;
  background-image: url("../assets/images/back.jpg");
  background: none;
}
form {
  margin: auto;
  width: 30%;
  padding: 10px;
}
b{
  color: rgba(66,147,167,1);
}
.logb {
  background-color: white;
  color:  rgba(66,147,167,1);
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
  box-shadow: 0px 0px 10px #0ff;
}
button:hover {
  opacity: 0.8;
}
.cancelbtn {
  width: auto;
  padding: 10px 18px;
  background-color: #f44336;
}
.imgcontainer {
  text-align: center;
  margin: 24px 0 12px 0;
}
.container1 {
  padding: 16px;
}
span.psw {
  float: right;
  padding-top: 16px;
}
.logo {
  /* position: fixed; */
  position: relative;
  margin: 0 auto;
}
@media (min-width: 0px) and (max-width: 460px) {
.fox {
  width: 300px;
  height: 100px;
}
.container1{
  width: 100px;
}
}
</style>
<style scoped>
input[type=text], input[type=password] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px #0ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue